import { create } from "zustand"
import { langStore } from "../../../../stores/lang-store"
import { dougnutBundle } from "./half-doughnut-const"

const calcRate = (part, total) => {
  return {
    pct: (part / total) * 100,
    leak: part,
    normal: total - part
  }
}

export const halfDoughnutStore = create((set) => ({
  doughnuts: [
    {
      id: "A",
      title: "주간 누수 수용가",
      unit: "가구",
      pct: 0,
      data: [
        { name: "누수", value: 1, bg: "#0050ff" },
        { name: "정상", value: 99, bg: "#8db5ff" }
      ]
    },
    {
      id: "B",
      title: "주간 누수율",
      unit: "m³",
      pct: 0,
      data: [
        { name: "누수", value: 1, bg: "#0050ff" },
        { name: "정상", value: 99, bg: "#8db5ff" }
      ]
    }
  ],

  setCharts: (overview) => {
    const { lang } = langStore.getState()

    const { total_leak_customers, total_customers, total_leak_amount, total_usage } = overview

    const customerRate = calcRate(total_leak_customers, total_customers)
    const leakRate = calcRate(total_leak_amount, total_usage)

    const doughnuts = [
      { id: "A", ...customerRate },
      { id: "B", ...leakRate }
    ].map((item, idx) => {
      return {
        id: item.id,
        title: dougnutBundle.groups[idx].title[lang],
        unit: dougnutBundle.groups[idx].unit[lang],
        pct: item.pct.toFixed(2),
        data: [
          { name: dougnutBundle.dataName.leak[lang], value: item.leak, bg: "#0050ff" }, // 누수,
          { name: dougnutBundle.dataName.normal[lang], value: item.normal, bg: "#8db5ff" } // 정상,
        ]
      }
    })

    set({ doughnuts })
  }
}))
